// extracted by mini-css-extract-plugin
export var chip = "_3w-0";
export var filterDropdown = "_3w-5";
export var filterItem = "_3w-6";
export var icon = "_3w-1";
export var removeButton = "_3w-3";
export var removeIcon = "_3w-4";
export var separator = "_3w-2";